import React from "react";
import {View} from "react-native";
import ScreenTemplate from "./ScreenTemplate";
import PtTabsContainer from "../components/core/pt-tabs/pt-tabs-container";
import styles from "./screen-styles";
import {getTranslation} from "../helpers/getTranslation";
import PtTab from "../components/core/pt-tabs/pt-tab";
import PtOrderHistoryPage from "../components/order-history/pt-order-history-page";
import PtDuePaymentsPage from "../components/due-payments/pt-due-payments-page";
import CreditLimit from "../components/pt-credit-limit/credit-limit";
import {isFeatureAvailable} from "../helpers/isFeatureAvailable";

/** set this to styles.withBoundaries to display borders around container views to visually debug layout overflows */
const showBoundaries = null;

export default function OrderHistoryScreen({navigation, route}:any) {

  return (
    <ScreenTemplate navigation={navigation} route={route}>

      <View style={[styles.pageContentSlotContainer, showBoundaries]}>

        <View>

          <PtTabsContainer>
            {isFeatureAvailable('orderHistory') ?
              <PtTab
                title={getTranslation('orders.order.history.tab.title')}
                tabId={'orders'}
                active={route.params.activeTab == 'orders'}
              >
                <PtOrderHistoryPage/>
              </PtTab>
              : null
            }
            {isFeatureAvailable('duePayments') ?
              <PtTab
                title={getTranslation('orders.due.payments.tab.title')}
                tabId={'duePayments'}
                active={route.params.activeTab == 'duePayments'}
              >
                {isFeatureAvailable('creditLimit') ?
                  <CreditLimit showTitle title={getTranslation('credit.limit.title')}/>
                  : null
                }
                <PtDuePaymentsPage/>
              </PtTab>
              : null
            }
          </PtTabsContainer>

        </View>
      </View>

    </ScreenTemplate>
  )

}
